export { baseRadioPropDefs as radioPropDefs } from './base-radio.props.js';
